import Vue from "vue";
import router from "./router";
import Vuex from "vuex";

Vue.use(Vuex);
// Vuex
const store = new Vuex.Store({
  state: {
    count: 0,
    city: "",
    cities: [],
    isLogged: false,
    token: null,
    api_url: process.env.VUE_APP_API_URL,
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    login(state) {
      try {
        myHeader = window.location.href;
        id_token = myHeader.split("id_token=")[1].split("&access_token")[0];
        state.token = id_token;
        console.log("Token:", state.token);
        state.isLogged = true;
        console.log("IsLogged set to:", state.isLogged);
        var myHeader, id_token;
      } catch {
        console.warn("Login failed. Could not extract token from the URL.");
      }
      router.push("/");
    },
    logout(state) {
      state.isLogged = false;
      console.log("IsLogged set to:", state.isLogged);
      state.token = null;
      router.push("/");
    },
    isLogged(state) {
      return state.isLogged;
    },
  },
});

export default store;
